import { render, staticRenderFns } from "./IRegSetting.vue?vue&type=template&id=7db8d4b4&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./IRegSetting.vue?vue&type=script&lang=js"
export * from "./IRegSetting.vue?vue&type=script&lang=js"
import style0 from "./IRegSetting.vue?vue&type=style&index=0&id=7db8d4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db8d4b4",
  null
  
)

export default component.exports